import { useNavigate } from 'react-router';

import { RowClickHandler } from '@/components/data-table/data-table';

export function useRowNavigationCallback<TData extends { id: string }>(
  baseUrl: string,
): RowClickHandler<TData> {
  const navigate = useNavigate();
  return (row, event) => {
    const url = `${baseUrl}/${row.id}`;
    const urlWithSearchParams = window.location.search
      ? `${url}?parentSearch=${encodeURIComponent(window.location.search)}`
      : url;
    if (event.ctrlKey || event.metaKey) {
      window.open(urlWithSearchParams, '_blank');
    } else {
      void navigate(urlWithSearchParams);
    }
  };
}
